
import { PageContext, _, dateUtil } from '@zto/zpage'
import { formatPrice } from '@/utils/math'
import {
  ZdsOrderDeliveryType,
  ZdsOrderDeliveryTypeOptions, ZdsOrderPayModeOptions,
  ZdsOrderRefundStatus,
  ZdsOrderStatus,
  ZdsOrderStatusOptions
} from "@/pages/orderlist/config";
import {
  batchDeliverGoodsHandle,
  deliverGoodsHandle,
  exportOut1688ExcelHandle, getOrderDetailHandle,
  refundDialog
} from "@/pages/orderlist/_actions";
import dayjs from "dayjs";
import {CouponStatus} from "@/config";

export default {
  body: {
    type: 'crud',

    actions: {
      query: { api: '/api/pc/order/queryOrderListPage' },
      // 批量发货
      batchDeliverGoods:{
        ...batchDeliverGoodsHandle()
      },
      // 导出1688表格
      exportOut1688Excel:{
        ...exportOut1688ExcelHandle(),
      },

      // 确认收货
      receiptGoods:{
        api: 'tuxi.zds.order.pc.manualReceipt',
        payload: { orderId: '${data.row.soNo}' },
        message: '当前订单是否确认已收货？'
      },

      deliverGoods: {
        ...deliverGoodsHandle(false)
      },
      refund:{
        ...refundDialog()
      },
      detail:{
        ...getOrderDetailHandle()
      },

      moreLogistics:{
        ...deliverGoodsHandle(true)
      }
    },

    search: {
      labelWidth: 100,
      span: 6,

      items: [
        { label: '订单编号', type: 'input', prop: 'soNo', span: 6 },
        { label: '订单状态',
          type: 'select',
          prop: 'orderStatus',
          options: ZdsOrderStatusOptions
        },
        // {
        //   label: '支付方式',
        //   type: 'select',
        //   prop: 'payPlatform',
        //   options: ZdsOrderPayModeOptions,
        //   // default: 'WECHAT'
        // },
        // {
        //   label: '是否物流发货',
        //   type: 'select',
        //   prop: 'fulfillmentType',
        //   options: ZdsOrderDeliveryTypeOptions,
        // },
        { label: '时间类型', type: 'select', prop: 'timeType',
          options: [
            { label: '下单时间',value:1 },
            { label: '付款时间',value:2 },
          ],
          clearable: false
        },
        // {
        //   label: '时间范围',
        //   labelWidth: 100,
        //   type: 'date-range-picker',
        //   prop: 'startDate',
        //   toProp: 'endDate',
        //   // span: 8
        // }
      ]
    },
    toolbar: {
      items: [
        { action: 'batchDeliverGoods', label: '批量发货' },
        // { action: 'exportOut1688Excel', label: '导出表格1688专用' },
        { action: 'exportInExcel', label: '导出列表' },
        // { action: 'exportInExcel', label: '导出明细' }
      ]
    },
    table: ({app}: PageContext) => ({
      operation: {
        width: 150,
        items: [
          {
            action: 'deliverGoods',
            label: '发货',
            // visibleOn: ({ data }: PageContext) => {
            //   const isExistRefund = [ZdsOrderRefundStatus.REFUNDING, ZdsOrderRefundStatus.REFUND_SUCCESS, ZdsOrderRefundStatus.REFUND_FAIL].includes(data.row.returnStatus);
            //   return [ZdsOrderStatus.WAIT_DELIVERY, ZdsOrderStatus.WAIT_RECEIVE,ZdsOrderStatus.PART_RECEIVE].includes(data.row.orderStatus) && data.row.deliveryMode === ZdsOrderDeliveryType.DROP_SHIPPING && !isExistRefund;
            // },
          },
          { action: 'detail' },
        ]
      },
      columns: [
        { label: '订单编号', prop: 'orderId', width: 200 },
        { label: '下单时间', prop: 'createTime', width: 200,
          formatter: (row: any) => {
            const date = dayjs(row.createTime)
            return date.format('YYYY-MM-DD HH:mm:ss')
          }
        },
        { label: '付款时间', prop: 'payTime', width: 200,formatter: (row: any) => {
          if (!row.payTime) {
            return '--'
          }
            const date = dayjs(row.payTime)
            return date.format('YYYY-MM-DD HH:mm:ss')
          } },
        { label: '订单金额', prop: 'totalPaymentAmount',
          formatter:(data: any) => {
            return formatPrice(data.totalPaymentAmount)
          },
          width: 100
        },

        { label: '订单状态', prop: 'orderStatus',
          formatter: { name: 'enumStr', options: ZdsOrderStatusOptions },
          // formatter: (data: any) => {
          //   // @ts-ignore
          //   return ZdsOrderStatusMap[data.orderStatus] || '--';
          // },
          width: 100
        },
        { label: '用户姓名', prop: 'receiverName',width: 100 },
        { label: '用户手机号', prop: 'receiverMobile', width: 100 },
        { label: '收货地址', prop: 'fullAddress', width: 100 },
        // { label: '是否物流发货', prop: 'deliveryMode',
        //   formatter: { name: 'enumStr', options: ZdsOrderDeliveryTypeOptions },
        //   // formatter: (data: any) => {
        //   //   // @ts-ignore
        //   //   return ZdsOrderDeliveryTypeMap[data.deliveryMode ] || '--';
        //   // },
        //   width: 100 },
        { label: '物流公司', prop: 'logisticsCompanyName', width: 100 },
        { label: '物流单号', prop: 'logisticsNo', width: 100 },
        // { label: '退款状态', prop: 'returnStatus',
        //   formatter: (data: any) => {
        //     // @ts-ignore
        //     return ZdsOrderRefundStatusMap[data.returnStatus ] || '--';
        //   },
        //   width: 100
        // },
        // { label: '员工姓名', prop: 'cardName', width: 100 },
        // { label: '员工工号', prop: 'cardNo', width: 100 },
        // { label: '员工手机号', prop: 'cardPhone', width: 100 },
      ]
    }),

  }
}
